import { useContext } from "react";
import LPContext from "../context/LPContext";
/**
 * Selects and returns the LPDetails from context
 * @returns LogisticPartyDetailsList
 */ function useLogisticParties() {
    var logisticParties = useContext(LPContext);
    return logisticParties.lps;
}
export default useLogisticParties;

//# sourceMappingURL=useLogisticParties.js.map